import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../services';
import { PAGE_ROUTES } from '@shared/core-data';

export const adminGuard: CanActivateFn = (): boolean => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (!userService.isAdmin()) {
    router
      .navigate(['/', PAGE_ROUTES.STATUS, PAGE_ROUTES.ACCESS_DENIED])
      .then();
    return false;
  }
  return true;
};
